import apicaller from "@/utils/apicaller";
import api from "@/main.api";
import constant from "@/main.constants";

// Bakım durumu kısa süreli cachelenir ve eş zamanlı sorgular tek istek üzerinden karşılanır.
// Böylece her route geçişinde ve 503 yönlendirmelerinde yeni istek atılmaz.
let cachedStatus = null;
let cachedAtMs = 0;
let pendingRequest = null;
// clearCache sonrası, öncesinde başlamış bir isteğin geçersiz sonucu cacheye yazmasını engeller.
let requestGeneration = 0;

const isCacheValid = () => cachedStatus !== null && Date.now() - cachedAtMs < constant.INTERVALS.MAINTENANCE_STATUS_CACHE_TIME;

export default {
  // Cache geçerliyse istek atmadan, değilse tek bir istek üzerinden bakım durumunu döner.
  getStatus() {
    if (isCacheValid()) {
      return Promise.resolve(cachedStatus);
    }
    if (pendingRequest) {
      return pendingRequest;
    }
    const generation = requestGeneration;
    pendingRequest = apicaller
      .get(api.PUBLIC.maintenance)
      .then(response => {
        const status = response && response.data ? response.data : { enabled: false };
        if (generation === requestGeneration) {
          cachedStatus = status;
          cachedAtMs = Date.now();
        }
        return status;
      })
      .finally(() => {
        if (generation === requestGeneration) {
          pendingRequest = null;
        }
      });
    return pendingRequest;
  },
  // Cache geçerli değilse null döner; çağıran taraf istek atmadan karar verir.
  getCachedStatus() {
    return isCacheValid() ? cachedStatus : null;
  },
  // 503 alındığında cachedeki "bakım kapalı" bilgisi geçersizleşir, sonraki sorgu sunucudan okur.
  clearCache() {
    cachedStatus = null;
    cachedAtMs = 0;
    pendingRequest = null;
    requestGeneration = requestGeneration + 1;
  }
};
